import { getBooleanLocalStorageKey, updateLocalStorageKey } from '../../utils';

export const IS_INFI_SPOTLIGHT_SEEN_KEY = 'is-infi-spotlight-seen';

export const getIsInfiSpotlightSeen = () => getBooleanLocalStorageKey(IS_INFI_SPOTLIGHT_SEEN_KEY);

export const setIsInfiSpotlightSeen = (isInfiSpotlightSeen: boolean) =>
	updateLocalStorageKey(IS_INFI_SPOTLIGHT_SEEN_KEY, isInfiSpotlightSeen.toString());
